window.Products.HomeDecor.PillowCase = function() {};
window.Products.HomeDecor.PillowCase.inherits(window.Products.HomeDecor.Pillow);